<template>
  <div class="reimbursement-container">
    <van-tabs v-model="activeName" @click="changeTab">
      <van-tab title="未报销" name="0"></van-tab>
      <van-tab title="已报销" name="1"></van-tab>
      <van-tab title="全部广告" name="2"></van-tab>
    </van-tabs>
    <van-checkbox-group v-model="checkedArr" ref="checkboxGroup">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="adList"
      >
        <van-cell v-for="(item, index) in list" :key="index">
          <template #icon>
            <van-checkbox
              :name="item.id"
              v-if="
                item.subReimbursed === false &&
                  item.purchaseCertificate === true &&
                  item.status > 6
              "
            ></van-checkbox>
            <div class="subReimbursed" v-if="item.subReimbursed === true">
              <van-icon name="passed" />
            </div>
            <div
              class="subReimbursed"
              v-if="
                (item.subReimbursed === false &&
                  item.purchaseCertificate === false) ||
                  item.status < 7
              "
              @click="handleTips"
            >
              <van-icon name="warning-o" />
            </div>
          </template>
          <template #title>
            <div class="custom-title" @click="handleDetail(item.id)">
              {{ item.createAt }}
            </div>
            <div class="custom-title" @click="handleDetail(item.id)">
              {{ item.partyBName }}
            </div>
            <div class="custom-title" @click="handleDetail(item.id)">
              <span
                :class="[
                  [
                    item.purchaseCertificate === true ? 'bgc-green' : 'bgc-gray'
                  ],
                  'certificate-status'
                ]"
              ></span>
              {{
                item.purchaseCertificate === true
                  ? "已上传进货凭证"
                  : "请上传进货凭证"
              }}
            </div>
          </template>
          <template #default>
            <span class="custom-title" @click="handleDetail(item.id)">
              {{ item.estimateTotalCost + "元" }}
            </span>
          </template>
        </van-cell>
      </van-list>
    </van-checkbox-group>
    <van-submit-bar
      v-if="activeName !== '1'"
      button-text="提交申请"
      @submit="onSubmit"
      safe-area-inset-bottom
    >
      <van-checkbox v-model="checkedAll" @click="checkAll">全选</van-checkbox>
    </van-submit-bar>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      activeName: sessionStorage.getItem("activeName") || "0",
      checkedArr: [],
      checkedAll: false,
      list: [],
      loading: false,
      finished: false,
      reimbursementData: {
        list: []
      },
      type: false
    };
  },
  methods: {
    // 广告列表
    adList() {
      switch (this.activeName) {
        case "0":
          this.type = false;
          break;
        case "1":
          this.type = true;
          break;
        case "2":
          this.type = "";
          break;
        default:
          break;
      }
      this.$api.applyList(this.type).then(res => {
        // console.log("广告列表", res.result);
        res.result.forEach((val, index) => {
          if (val.status === 9) {
            res.result.splice(index, 1);
          }
        });
        this.list = res.result;
        this.loading = false;
        this.finished = true;
      });
    },
    // 全选
    checkAll() {
      if (this.checkedAll) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    // 提交
    onSubmit() {
      // console.log(this.checkedArr);
      if (this.checkedArr.length === 0) {
        return;
      }
      this.reimbursementData.list = this.checkedArr;
      this.$api.submitReimburs(this.reimbursementData).then(res => {
        // console.log("res: ", res);
        if (res.code === 0) {
          Dialog.alert({
            title: "提示",
            message: "已提交",
            confirmButtonText: "关闭"
          }).then(() => {
            this.checkedArr = [];
            this.adList();
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: "提交失败,请检查",
            confirmButtonText: "关闭"
          });
        }
      });
    },
    // 标签页
    changeTab() {
      this.adList();
    },
    // 协议详情
    handleDetail(id) {
      // console.log("id: ", id);
      sessionStorage.setItem("activeName", this.activeName);
      this.$router.push({
        path: "/agency/deal-detail",
        query: {
          id: id
        }
      });
    },
    // 提示
    handleTips() {
      Dialog.alert({
        title: "温馨提示",
        message: "上传进货凭证并且公司核价后才可报销",
        confirmButtonText: "关闭"
      });
    }
  }
};
</script>
<style lang="scss" scope>
.reimbursement-container {
  padding-bottom: 30px;

  .van-submit-bar__bar {
    justify-content: space-around;
  }

  .van-cell__value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .van-checkbox {
    margin-right: 10px;
  }

  .subReimbursed {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-size: 20px;
  }

  .certificate-status {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .bgc-green {
    background-color: green;
  }

  .bgc-gray {
    background-color: gray;
  }

  .custom-title {
    text-align: left;
    color: gray;
  }

  .custom-title:nth-child(2) {
    color: black;
  }

  .van-submit-bar {
    bottom: 50px;

    .van-submit-bar__bar {
      height: 30px;
    }

    .van-submit-bar__button {
      height: 25px;
      line-height: 25px;
    }
  }
}
</style>
